module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-27.cfd8c67a.png";